module.exports = __webpack_public_path__ + "img/Baumwipfelquatsch.22458f5a.svg";